"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importFileStatuses = void 0;
var importFileStatuses;
(function (importFileStatuses) {
    // File upload http handler
    importFileStatuses["FILE_UPLOAD_COMPLETED"] = "fileUploadCompleted";
    // ETL file event handler
    importFileStatuses["FILE_ETL_IN_PROCESS"] = "fileEtlInProcess";
    importFileStatuses["FILE_ETL_COMPLETED"] = "fileEtlCompleted";
    importFileStatuses["FILE_ETL_FAILED"] = "fileEtlFailed";
    // import file event handler
    importFileStatuses["FILE_ENTITY_VALIDATION_IN_PROCESS"] = "fileEntityValidationInProcess";
    importFileStatuses["FILE_ENTITY_VALIDATION_FAILED"] = "fileEntityValidationFailed";
    importFileStatuses["FILE_ROWS_VALIDATION_IN_PROCESS"] = "fileRowsValidationInProcess";
    importFileStatuses["FILE_ROWS_VALIDATION_COMPLETED"] = "fileRowsValidationCompleted";
    importFileStatuses["FILE_ROWS_VALIDATION_FAILED"] = "fileRowsValidationFailed";
    // Generate import report event handler
    importFileStatuses["PERSISTING_ENTRIES_IN_PROCESS"] = "persistingEntriesInProcess";
    importFileStatuses["PERSISTING_ENTRIES_FAILED"] = "persistingEntriesFailed";
    importFileStatuses["GENERATE_REPORT_IN_PROCESS"] = "generateReportInProcess";
    importFileStatuses["GENERATE_REPORT_FAILED"] = "generateReportFailed";
    importFileStatuses["DONE"] = "done";
})(importFileStatuses || (exports.importFileStatuses = importFileStatuses = {}));
